module.exports = __webpack_public_path__ + "static/collaboration-section-bg-8d68a425ea2c05e2f8985d2ee78a0ff1.webp";